export const environment = {
  production: false,
  testMode: true,
  termsAPIUrl: 'https://api-villkor-test.lana.sparbankensyd.se/terms',
  lrApiUrl: 'https://api-loan-renewal-test.internal.sparbankensyd.se/api',
  authServiceUrl: 'https://spb-common-api-stage.internal.sparbankensyd.se/service',
  signUrl: 'https://spb-common-api-stage.internal.sparbankensyd.se/service',
  domain: 'https://villkor-test.lana.sparbankensyd.se/'
}
